<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col class="table-size">
        <b-card
          title="جزئیات بنر"
        >
          <b-form
            ref="bannerform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="8"
                offset-md="2"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      label="تصویر دسکتاپ"
                    >
                      <b-media class="mb-2">
                        <template #aside>
                          <b-avatar
                            ref="previewDesktop"
                            :src="Form.ImageDesktop"
                            size="90px"
                            rounded
                            button
                            @click="$refs.refInputDesktop.click()"
                          />
                        </template>
                        <input
                          ref="refInputDesktop"
                          type="file"
                          class="d-none"
                          name="ImageDesktop"
                          accept="image/*"
                          @input="imageRenderer($event, 'ImageDesktop')"
                        >
                        <small class="text-muted">برای انتخاب تصویر روی کادر کلیک کنید (نمایش در دسکتاپ)</small>
                      </b-media>
                    </b-form-group>
                  </b-col>

                  <b-col
                    class="image"
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      label="تصویر موبایل"
                    >
                      <b-media class="mb-2">
                        <template #aside>
                          <b-avatar
                            ref="previewMobile"
                            :src="Form.ImageMobile"
                            size="90px"
                            rounded
                            button
                            @click="$refs.refInputMobile.click()"
                          />
                        </template>
                        <input
                          ref="refInputMobile"
                          type="file"
                          class="d-none"
                          name="ImageMobile"
                          accept="image/*"
                          @input="imageRenderer($event, 'ImageMobile')"
                        >
                        <small class="text-muted">اختیاری؛ در صورت خالی بودن، تصویر دسکتاپ نمایش داده می‌شود</small>
                      </b-media>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="عنوان (متن جایگزین تصویر)"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="لینک"
                      label-for="Link"
                    >
                      <b-form-input
                        id="Link"
                        v-model="Form.Link"
                        name="Link"
                        autocomplete="off"
                        dir="ltr"
                        placeholder="https://..."
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="اولویت نمایش"
                      label-for="Priority"
                    >
                      <b-form-input
                        id="Priority"
                        v-model="Form.Priority"
                        name="Priority"
                        type="number"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="باز شدن لینک در تب جدید"
                      label-for="OpenInNewTab"
                    >
                      <v-select
                        v-model="Form.OpenInNewTab"
                        :options="enums('OpenInNewTab')"
                        dir="rtl"
                        label="text"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'BannerDetails',
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        ImageDesktop: null,
        ImageMobile: null,
        Link: null,
        OpenInNewTab: false,
        Priority: 0,
        IsActive: true,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.banner.add
      if (this.$route.params.id) {
        url = this.$api.banner.update
      }

      const formData = new FormData(this.$refs.bannerform)
      formData.append('Id', this.Form.Id)
      formData.append('OpenInNewTab', this.Form.OpenInNewTab)
      formData.append('IsActive', this.Form.IsActive)

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event, key) {
      const file = event.target.files[0]
      if (!file) {
        return
      }

      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)

      fileReader.onload = () => {
        this.Form[key] = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.banner.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
